import { ALIGNMENT } from '../../../../utils/constants/alignment';

export const SCOUT_LOAD_MODAL_HEADERS = [
  {
    id: 'id',
    key: 'id',
    isHidden: true,
  },
  {
    id: 'creatorId',
    key: 'creatorId',
    isHidden: true,
  },
  {
    id: 'name',
    key: 'name',
    label: 'Name',
    isSortable: true,
    alignment: ALIGNMENT.LEFT,
  },
  {
    id: 'metricCount',
    key: 'metricCount',
    label: 'Filters',
    isSortable: true,
    alignment: ALIGNMENT.LEFT,
  },
  {
    id: 'lastEditor',
    key: 'lastEditor',
    label: 'Owner',
    isSortable: true,
    alignment: ALIGNMENT.LEFT,
  },
  {
    id: 'lastModified',
    key: 'lastModified',
    label: 'Last Modified',
    isSortable: true,
    alignment: ALIGNMENT.LEFT,
    width: 150,
  },
  {
    id: 'actions',
    key: 'actions',
    isSortable: false,
    alignment: ALIGNMENT.RIGHT,
    width: 10,
  },
];
